'use strict';

function getBadCriteriaIds () {
  var badcriteriaIds = [];

  $('.criterium.result-2, .criterium.result-3').each(function () {
    var criteriumName = $(this).attr('id').replace(/^criterium-/, '');
    return badcriteriaIds.push(criteriumName);
  });
  return badcriteriaIds;
}

module.exports = getBadCriteriaIds;
